export default {
  title: "Abonnement",
  currentPlan: "Dein aktuelles Abonnement",
  free: "Kostenlos",
  manage: "Mein Abonnement verwalten",
  pageTitle: "Unsere Abonnementpläne",
  pageDescription: "Wähle den Plan, der am besten zu deinen Bedürfnissen passt",
  subscriptionUpdated: "Dein Abonnement wurde erfolgreich aktualisiert",
  updateError: "Beim Aktualisieren deines Abonnements ist ein Fehler aufgetreten",
  mostPopular: "Am beliebtesten",
  choosePlan: "Diesen Plan wählen",
  unlimited: "Unbegrenzt",
  freePrice: "0€",
  essentialPrice: "{{price}}€/Monat",
  proPrice: "{{price}}€/Monat",
  freeDescription: "Perfekt, um mit deiner Hochzeitsplanung zu beginnen",
  essentialDescription: "Ideal für Hochzeiten mit bis zu 200 Gästen",
  proDescription: "Für größere Hochzeiten mit spezifischen Anforderungen",
  viewPlans: "Pläne anzeigen",
  featureRestricted: "Eingeschränkte Funktion",
  upgradeToAccessFeature: "Upgrade, um auf {{feature}} zuzugreifen",
  upgradeToAccessPlan: "Upgrade auf den {{plan}}-Plan, um auf diese Funktion zuzugreifen",
  upgradeToIncreaseLimits: "Upgrade, um diese Limits zu erhöhen",
  limitReached: "{{limit}}-Limit erreicht ({{count}}/{{max}})",
  plans: {
    free: "Kostenlos",
    essential: "Essential",
    pro: "Pro",
    premium: "Premium"
  },
  currentPlanMessage: {
    free: "Du nutzt den kostenlosen Plan",
    pro: "Du bist Premium-Mitglied!"
  },
  eventsUsed: "Verwendete Ereignisse",
  features: {
    title: "Funktionen",
    exportPDF: "PDF-Export",
    exportExcel: "Excel-Export",
    customDomain: "Benutzerdefinierte Domain",
    adsRemoval: "Keine Werbung",
    prioritySupport: "Prioritäts-Support",
    guestGroups: "Gästegruppen",
    seatingPlanner: "Sitzplaner",
    budgetAnalytics: "Budget-Analysen",
    weddingWebsite: "Hochzeitswebsite",
    aiAssistant: "KI-Assistent",
    customTemplates: "Benutzerdefinierte Vorlagen",
    mobileApp: "Mobile App",
    webhookIntegrations: "Webhook-Integrationen",
    multiLanguage: "Mehrsprachig",
    customFields: "Benutzerdefinierte Felder"
  },
  limits: {
    title: "Limits",
    maxGuests: "Gäste",
    maxTasks: "Aufgaben",
    maxVendors: "Dienstleister",
    maxCollaborators: "Mitarbeiter",
    maxBudgetItems: "Budget-Posten",
    maxTimelineEvents: "Zeitplanereignisse"
  },
  faq: {
    title: "Häufig gestellte Fragen",
    question1: "Kann ich jederzeit den Plan wechseln?",
    answer1: "Ja, du kannst jederzeit zwischen den Plänen wechseln. Bei einem Upgrade wird dir der restliche Monat anteilig berechnet. Bei einem Downgrade tritt die Änderung am Ende deines aktuellen Abrechnungszeitraums in Kraft.",
    question2: "Was passiert, wenn ich meine Limits überschreite?",
    answer2: "Wenn du die Limits deines Plans erreichst, wirst du aufgefordert, auf einen höheren Plan umzusteigen, um mehr Elemente hinzuzufügen.",
    question3: "Wie funktioniert die Abrechnung?",
    answer3: "Die Abrechnung erfolgt monatlich und automatisch. Du kannst dein Abonnement jederzeit über dein Konto kündigen.",
    question4: "Kann ich eine Rückerstattung erhalten?",
    answer4: "Wir bieten eine vollständige Rückerstattung innerhalb von 14 Tagen nach deinem ersten kostenpflichtigen Abonnement an, wenn du mit unseren Dienstleistungen nicht zufrieden bist.",
    multipleEventsQuestion: "Kann ich mehrere Veranstaltungen verwalten?",
    multipleEventsAnswer: "Mit dem Pro-Plan können Sie unbegrenzt Veranstaltungen verwalten. Kostenlose und wesentliche Pläne sind auf ein Ereignis beschränkt."
  },
  plan: {
    free: "Kostenlos",
    basic: "Basic",
    premium: "Premium",
    pro: "Pro",
    essential: "Essential"
  },
  usingBasicFeatures: "Nutzung grundlegender Funktionen",
  multipleEventsRestricted: "Die Verwaltung mehrerer Veranstaltungen ist begrenzt",
  upgradeToProForMultipleEvents: "Auf Pro upgraden, um mehrere Ereignisse zu verwalten",
  billing: {
    monthly: "Monatlich",
    yearly: "Jährlich",
    save: "Sparen Sie {{percent}}%"
  },
  actions: {
    upgrade: "Aktualisieren",
    downgrade: "Herabstufen",
    cancel: "Abonnement kündigen",
    reactivate: "Abonnement reaktivieren"
  },
  messages: {
    upgradeSuccess: "Ihr Plan wurde erfolgreich aktualisiert",
    downgradeSuccess: "Ihr Plan wurde erfolgreich herabgestuft",
    cancelSuccess: "Ihr Abonnement wurde storniert",
    reactivateSuccess: "Ihr Abonnement wurde reaktiviert"
  }
,

  pageSubtitleNew: "Passen Sie WedBox mit unseren flexiblen Plänen an Ihre Bedürfnisse an",
  refreshBtn: "Aktualisieren",
  popular: "Beliebt",
  current: "Aktuell",
  freePlanBtn: "Kostenloser Plan",
  upgradeTo: "Upgrade auf {{plan}}",
  currentPlanBtn: "Aktueller Plan",
  usage: {
    events: "Veranstaltungsverwaltung",
    guests: "Gäste",
    tasks: "Aufgaben",
    vendors: "Dienstleister"
  },
  units: {
    events: "Veranstaltung(en)",
    guests: "Gast/Gäste",
    tasks: "Aufgabe(n)",
    vendors: "Dienstleister"
  },
  checkout: {
    title: "Sichere Zahlung",
    secureStripe: "Sichere Zahlung mit Stripe",
    cancelAnytime: "Sie können Ihr Abonnement jederzeit über Ihr Konto kündigen.",
    lastRefresh: "Letzte Aktualisierung:",
    mustBeLoggedIn: "Sie müssen angemeldet sein, um zur Zahlung zu gelangen",
    freeNoPayment: "Der kostenlose Plan erfordert keine Zahlung",
    creatingSession: "Zahlungssitzung wird erstellt...",
    redirecting: "Weiterleitung zu Stripe...",
    subscribeTo: "Abonnieren Sie den {{plan}}-Plan",
    cancel: "Abbrechen",
    securePayment: "Sichere Zahlung über Stripe"
  },
  planDetails: {
    free: {
      name: "Kostenlos",
      price: "0€",
      description: "Perfekt für den Start",
      features: [
        "1 Veranstaltung verwalten",
        "Bis zu 50 Gäste",
        "Max 20 Aufgaben",
        "10 Dienstleister",
        "Community-Support"
      ]
    },
    essential: {
      name: "Essential",
      price: "9€",
      description: "Für wichtige Veranstaltungen",
      features: [
        "3 Veranstaltungen verwalten",
        "Bis zu 200 Gäste",
        "Unbegrenzte Aufgaben",
        "25 Dienstleister",
        "PDF/Excel-Export",
        "Gästegruppen",
        "Bevorzugter Support"
      ]
    },
    pro: {
      name: "Pro",
      price: "19€",
      description: "Komplette Lösung",
      features: [
        "Unbegrenzte Veranstaltungen",
        "Unbegrenzte Gäste",
        "Unbegrenzte Aufgaben",
        "Unbegrenzte Dienstleister",
        "Sitzplaner",
        "Erweiterte Analysen",
        "Benutzerdefinierte Berichte",
        "Premium-Support"
      ]
    }
  }

};
